import { format, parseISO } from 'date-fns';
import { nb } from 'date-fns/locale';

/**
 * Formats a NOK amount as a Norwegian currency string.
 * e.g. 10490 → "10 490 kr"
 */
export const formatNok = (amountNok: number): string =>
  new Intl.NumberFormat('nb-NO', {
    style: 'currency',
    currency: 'NOK',
    maximumFractionDigits: 0,
  }).format(amountNok);

/**
 * Formats a number with Norwegian thousands grouping, no currency symbol.
 * e.g. 10490 → "10 490". Use when the caller appends its own unit suffix
 * (e.g. "NOK inkl. mva").
 */
export const formatNumber = (n: number): string =>
  new Intl.NumberFormat('nb-NO', { maximumFractionDigits: 0 }).format(n);

/**
 * Formats an ISO date string (yyyy-MM-dd or full ISO) as a long Norwegian date.
 * e.g. "2026-06-15" → "15. juni 2026"
 * Returns "—" for empty/invalid input.
 */
export const formatDate = (iso: string): string => {
  if (!iso) return '—';
  try {
    return format(parseISO(iso), 'd. MMMM yyyy', { locale: nb });
  } catch {
    return '—';
  }
};
